import {
  API,
} from 'settings'

export const getApiUrl = (filepath) => {
  return `${API}/storage/download?filepath=${encodeURIComponent(filepath)}`
}

export const getUrl = (filepath) => {
  // const prefix = process.env.NODE_ENV == 'development' ?
  //   'dev' :
  //   'prod'
  const prefix = 'prod'
  return `https://storage.googleapis.com/booking-system-assets/${prefix}/${filepath}`
}